import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useEditExamInstanceMonitor = () => {

    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();

    const editExamInstance = async (examPeriod: any) => {
        try {
            await axios.put(`/api/examinstance/monitor`, examPeriod);
        } catch (error) {
            throw new Error(t("messages.error.editExamInstanceMonitor"));
        }
    }

    return useMutation({mutationFn: editExamInstance, onSuccess: (_, vars) => {
        queryClient.setQueryData(["examPeriods", vars.examId, "monitor"], (old: any) => {
            return old.map((item: any) => {
                if (vars.ids.includes(item.id)) {
                    return {
                        ...item,
                        state: vars.newState
                    }
                }
                return item;
            });
        });
        queryClient.invalidateQueries({queryKey: ["examPeriods", vars.examId]});
    }});
}